module.exports = __webpack_public_path__ + "static/media/bg3.cdcdaef2.png";